import styled, { mediaQuery, css, theme } from 'academy-common-lib/utils/Styling';
import { appendHubsContent, trackFooterLinkClick } from '../../../../utils/urls';
import { getPublicLang } from 'academy-common-lib/utils/url';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBadge from 'UIComponents/badge/UIBadge';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledLink = styled(UILink).withConfig({
  displayName: "NavGroupLink__StyledLink",
  componentId: "f4eytk-0"
})(["text-align:center;display:block;padding:16px;border-top:1px solid ", ";", ""], theme.colors.HEFFALUMP, mediaQuery('notTablet', css(["padding:6px 0;text-align:left;border-top:none;"])));
const publicLang = getPublicLang();
const NavGroupLink = ({
  link
}) => {
  const href = link.hrefs[publicLang] || link.hrefs.en;
  if (!href) return null;
  const shouldDisplayEnglishLanguageTag = publicLang !== 'en' && href === link.hrefs.en;
  return /*#__PURE__*/_jsx("li", {
    children: /*#__PURE__*/_jsxs(StyledLink, {
      className: "footer-link",
      href: appendHubsContent(href, I18n.text(link.i18nKey)),
      onClick: () => trackFooterLinkClick(href),
      use: "unstyled",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: link.i18nKey
      }), shouldDisplayEnglishLanguageTag && /*#__PURE__*/_jsx(UIBadge, {
        className: "m-left-2",
        style: {
          display: 'inline-block',
          verticalAlign: 'text-bottom'
        },
        use: "candy-apple",
        children: publicLang === 'ja' ? '英' : 'EN'
      })]
    })
  }, link.i18nKey);
};
export default NavGroupLink;